import ApplyTermsAndConditions from './TermsAndConditions';
import ApplyWelcome from './Welcome';
import ApplyYourInfo from './YourInfo';
import { useApplyContext } from './context';

const ApplyContent: React.FunctionComponent = function () {
  const { page } = useApplyContext();
  switch (page) {
    case 'WELCOME':
      return <ApplyWelcome />;
    case 'TERMS_AND_CONDITIONS':
      return <ApplyTermsAndConditions />;
    case 'YOUR_INFO':
      return <ApplyYourInfo />;
    default:
      return <div>Error</div>;
  }
};

export default ApplyContent;
